// Lightweight device/capability detection used to decide whether the receipt
// scanner (live camera + OCR) can run on this device, or whether to show the
// "open on your phone / download the app" message instead.

/**
 * True when the app is running on a phone/tablet. Uses the user agent plus an
 * iPadOS check (iPadOS 13+ reports a desktop Safari UA, so it's detected via
 * touch points on a "Mac").
 */
export function isMobileDevice(): boolean {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    const uaMobile =
        /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(ua);
    const iPadOS =
        navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1;
    return uaMobile || iPadOS;
}

/** True when the browser exposes a camera capture API. */
export function hasCameraSupport(): boolean {
    return !!(
        typeof navigator !== "undefined" &&
        navigator.mediaDevices &&
        typeof navigator.mediaDevices.getUserMedia === "function"
    );
}

/**
 * True when this device can actually scan a receipt: a mobile device that
 * exposes a camera API. Whether a camera is physically present and permitted is
 * confirmed when the stream is requested.
 */
export function canScanReceipt(): boolean {
    return isMobileDevice() && hasCameraSupport();
}
